<style scoped lang="scss">
.table-list {
  min-height: calc(100% - 414px);
  display: flex;
  flex-direction: column;
  gap: 10px; 
  .page-tools-top {
        float: right;
        margin-top: 10px;
        margin-right: 10px;
        margin-left: 20px;
        width: 150px;
        .el-input__icon {
          font-size: 18px;
        }
    }
  .table-body {
    margin-top: 10px;
  }
  .footer-btns {
    margin-top: 20px;
    padding: 0 44px;
  }
}
</style>
 
<template>
  <div class="table-list">
    <div class="page-tools-top">
      <select-model
          ref="selectModel"
          v-model="filterModels"
          multiple
          :defaultSelectAll = "true"
          selectAll
          :disabled="loading"
          @change="filterTableData"
      ></select-model>
    </div>
    <div class="table-body">
    <TablePagination
      :height="tabelHeight"
      :tableData="pageTableData"
      :columnData="tableColumn"
      :total="tabelTotal"
      :currentPage.sync="tabelSearch.currentPage"
      :pageSize.sync="tabelSearch.pageSize"
      :updated="false"
      :waiting="waiting"
      selectionShow
      @changeCurrentPage="getTableData"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange">
    </TablePagination>
  </div>
    <div class="footer-btns">
      <el-button class="footer-btn" type="primary" plain @click="cancel">{{$t("cancel")}}</el-button>
      <el-button v-show="stopShow && stopShow2" class="footer-btn" type="primary" @click="stop">{{$t("device.stop")}}</el-button>
      <el-button class="footer-btn" type="primary" @click="confirm" :loading="loading" :disabled="!multipleSelection.length">{{$t("addSelected")}}</el-button>
      <el-button v-show="!((stopShow && stopShow2) || tabelTotal == 0)" class="footer-btn" type="primary" @click="addAll">{{$t("confirmAddAll")}}</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { stopScanDevice, getDeviceInfo, getScannedDevice, addAllScannedDevice } from '@/api/device.js'
import { TablePagination, SelectModel } from '@/components'

export default {
  name: 'tabel-list',
  components: {
    TablePagination,
    SelectModel,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Object,
    tabelData: Array,
    loading: Boolean,
    scanedDevice: Number,
  },
  data() {
    return {
      order: undefined,
      prop: undefined,
      tabelSearch: {
        currentPage: 1,
        pageSize: 10,
        model: null,
      },
      tableColumn: [
        {
          label: this.$t('device.IpAddress'),
          prop: 'publicIp',
          minWidth: '120',
          sortable: 'custom'
        },
        {
          label: this.$t('device.macAddress'),
          prop: 'macAddress',
          minWidth: '140',
          sortable: 'custom',
          filter: 'toUpperCase'
        },
        {
          label: this.$t('device.model'),
          prop: 'deviceModel',
          minWidth: '100',
          sortable: 'custom'
        },
        {
          label: this.$t('status'),
          prop: 'status',
          minWidth: '100',
          sortable: 'custom'
        },
        {
          label: this.$t('device.firmwareVersion'),
          prop: 'version',
          minWidth: '180',
          sortable: 'custom'
        },
      ],
      multipleSelection: [],
      stopShow2: true,
      filterModels: [],
      prevWaiting: true,
      tableData: [],
      total: 0
    }
  },
  computed: {
    ...mapGetters('session', ['pageTabelHeight']),
    stopShow() {
      return this.value.scanTotal == this.value.scanTotalNum ? false : true
    },
    newValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },
    newTableData() {
      const arr = [...this.tabelData]
      console.log("newTableData", arr)
      if(this.order) {
        arr.sort((a, b) => {
          if(typeof a[this.prop] == 'number') {
            return a[this.prop] - b[this.prop]
          } else {
            var A = a[this.prop].toUpperCase()
            var B = b[this.prop].toUpperCase()
            if (A < B) {
              return -1;
            }
            if (A > B) {
              return 1;
            }
          }
          return 0;
        })
        if(this.order =='desc') arr.reverse()
      }
      return arr
    },
    pageTableData() {
      //console.log("pageTableData pageSize:%d currentPage%d newTableDAta",this.tabelSearch.pageSize, this.tabelSearch.currentPage, this.newTableData)
      //return this.newTableData
      if (this.waiting) {
        return this.newTableData.slice(
          this.tabelSearch.pageSize * (this.tabelSearch.currentPage - 1),
          this.tabelSearch.pageSize * this.tabelSearch.currentPage
        )
      } else {
        return this.newTableData
      }
    },
    tabelTotal() {
      //console.log("tabelTotal ",this.tabelData.length,  this.scanedDevice)
      if (this.waiting)
        return this.scanedDevice == 0 ? this.tabelData.length : this.scanedDevice
      else
        return this.total
    },
    tabelHeight() {
      const height = this.pageTabelHeight - 414
      return height < 285 ? 285 : height
    },
    waiting() {
      return ((this.stopShow && this.stopShow2) || this.getScannedDevice == 0)
    }
  },
  mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  
  beforeDestroy() {
    // 正常离开页面时移除监听器
    console.log("beforeDestroy", this.stopShow2)
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.cleanUp();
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave ", this.stopShow2)
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    this.cleanUp();
  },
  watch: {
    waiting(value) {
      if (value == false && this.prevWaiting != value) {
        if (this.tabelData.length > 0) {
          //this.$emit(refreshDeviceList)
          getScannedDevice(this.tabelSearch).then(({data}) => {
            this.tabelData = data.result.rows[0].list
            this.total = data.result.rows[0].total
            console.log("getScannedDevice when watching waiting", data, this.currentPage)
          })
        }
      }
      this.prevWaiting = value
    }
  },
  methods: {
    // 多选框变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 取消
    cancel() {
      this.$emit('cancel')
    },
    // 确定
    confirm() {
      let params = []
      this.multipleSelection.forEach((e) => {
        params.push({
          deviceModel: e.deviceModel,
          macAddress: e.macAddress,
          publicIp: e.publicIp,
          status: e.status,
          version: e.version,
        })
      })
      getDeviceInfo(params).then(({data}) => {
        this.$message.success(data.message)
        this.$emit('confirm')
      })
    },
    addAll() {
      let params = this.filterModels
      
      addAllScannedDevice(params).then(({data}) => {
        this.$message.success(data.message)
        this.$emit('confirm')
      })
    },
    // 停止
    stop() {
      stopScanDevice({
        threadUUID: this.newValue.threadUUID,
      }).then(({data}) => {
        this.$message.success(data.message)
        this.stopShow2 = false
      })
      
      this.waiting = false
      this.$emit('stop')
    },
    filterTableData() {
      this.tabelSearch.model = this.filterModels
      this.tabelSearch.currentPage = 1
      //this.$emit('filter-change', this.filterModels)
      getScannedDevice(this.tabelSearch)
        .then((res) => {
          console.log("filterTableData %d", res.data.result.rows[0].total, res)
          this.tabelData = res.data.result.rows[0].list // 表格数据
          
          this.total = res.data.result.rows[0].total // 表格数据条目
          console.log("getTAbleData total %d tabelData ", this.tabelTotal, this.tabelData)
          
          this.$refs.refTable.clearFilter() // 表格过滤清空
          //if (this.devices.length) this.init()
        })
        .catch(() => {})
    },
    handleSortChange({ order, prop }) {
      this.order = order
      this.prop = prop
    },
    cleanUp() {
      this.stop()
    },
    getTableData() {
      console.log("getTableData getScannedDevice", this.tabelSearch.currentPage, this.tabelSearch.pageSize)
      getScannedDevice(this.tabelSearch)
        .then((res) => {
          this.tabelData = res.data.result.rows[0].list // 表格数据
          this.total = res.data.result.rows[0].total // 表格数据条目
          console.log("getTAbleData total %d list", this.tabelTotal, this.tabelData)
          
          this.$refs.refTable.clearFilter() // 表格过滤清空
          //if (this.devices.length) this.init()
        })
        .catch(() => {})
    },
    handleBeforeUnload(event) {
      // 在这里执行清理操作
      console.log("handleBeforeUnload",this.stopShow2)
      if (this.stopShow2 && this.stopShow) {
        event.preventDefault();
        event.returnValue = '';
      } else {
        this.cleanUp();
      }
      // 如果需要显示确认对话框（可选）
    },
  },
}
</script>
